import styled from 'styled-components';

import { isMobile, isTablet } from 'react-device-detect';

import { sharedStyles } from '../sharedStyles';

import { MIN_TX_HEIGHT } from '../TransactionPage/styles';

export { MIN_TX_HEIGHT };

export const RegTxListRow = styled.div`
  display: flex;
  align-items: stretch;
  padding-left: ${({ theme }) => theme.mixins.register.rowInnerPadding}px;
  padding-right: ${({ theme }) => theme.mixins.register.rowInnerPadding}px;
  border-bottom: solid 1px ${({ theme }) => theme.palette.background.subtle};

  &.flashTx {
    animation: pulseTx 0.3s ease-in;
  }
  @keyframes pulseTx {
    0%, 100% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(10px);
    }
    70% {
      transform: translateY(20px);
    }
  }
  &.comfortable {
    min-height: ${MIN_TX_HEIGHT.comfortable}px;
  }
  &.normal {
    min-height: ${MIN_TX_HEIGHT.normal}px;
  }
  &.compact {
    min-height: ${MIN_TX_HEIGHT.compact}px;
  }
  &.comfortable-ie {
    height: ${MIN_TX_HEIGHT.comfortable}px;
    overflow: 'hidden';
  }
  &.normal-ie {
    height: ${MIN_TX_HEIGHT.normal}px;
    overflow: 'hidden';
  }
  &.compact-ie {
    height: ${MIN_TX_HEIGHT.compact}px;
    overflow: 'hidden';
  }
`;

export const RegListItem = styled.div`
  &.popAmount {
    animation: pulse 0.5s ease-in;
  }
  @keyframes pulse {
    0%, 100% {
      transform: scale(1) translateX(0px);
    }
    50% {
      transform: scale(1.5) translateX(10px);
    }
  }
`;

export const RegTxList = styled.div`
  margin-top: 0;
  opacity: 1;
  font-size: 12px;
  font-weight: 400;
  font-family: Roboto, sans-serif;
  background: ${({ theme }) => theme.palette.background.paper};

  border-bottom: none;
  border-width: 1px;
  border-bottom-width: 1px;
  border-color: ${({ theme }) => theme.palette.background.elevated};
  border-bottom-color: ${({ theme }) => theme.palette.background.elevated};

  &.appear {
    opacity: 1;
    transition: all 0.5s ease;
  }
  &:hover {
    background: ${isMobile || isTablet ? '' : ({ theme }) => theme.mixins.register.rowHoverColor};
    transition: .5s ease;
    borderRadius: 3px;
    cursor: 'default';
  }
  &.editable {
    background: ${({ theme }) => theme.mixins.register.editRowColor};
    &:hover: {
      background: ${({ theme }) => theme.mixins.register.editRowColor};
    }
  }
  &.pending {
  }
`;

export const styles = (theme) => ({
  ...sharedStyles(theme),

  matchStateIcon: {
    display: 'flex',
    fontSize: '20px',
    '&.bank': {
      cursor: 'default',
      color: theme.palette.primary.main,
    },
    '&.manual': {
      cursor: 'default',
      color: theme.palette.primary.main,
    },
    '&.matched': {
      cursor: 'default',
      color: theme.palette.secondary.dark,
    },
    '&.scheduled': {
      cursor: 'default',
      color: theme.palette.other.dueTxn,
    },
  },

  regPendingText: {
    color: theme.mixins.register.pendingTextColor,
  },
  reviewed: {
    display: 'flex',
    cursor: 'pointer',
    color: theme.palette.text.tertiary,
    '&.not-reviewed': {
      color: theme.palette.info.main,
      fontSize: 'small',
    },
    '&.reviewed': {
      opacity: 1,
      color: theme.palette.text.disabled,
      fontSize: 'small',
    },
    '&.cancel': {
      opacity: 1,
      color: theme.palette.text.tertiary,
    },
    '&.save': {
      opacity: 0.8,
      color: theme.palette.success.dark,
    },
  },
  notReviewed: {
    cursor: 'pointer',
  },
  regInput: {
    color: theme.palette.text.strong,
    paddingBottom: '0px',
    paddingTop: 0,
    marginTop: '0px',
    fontSize: theme.mixins.register.fontSize.default,
    width: '100%',
    '& input': {
      padding: '0px',
      paddingBottom: '0px',
      fontSize: theme.mixins.register.fontSize.default,
      height: 24, // IE-11 needs this
      '&::-ms-clear ': {
        display: 'none',
      },
    },
  },
  buttonRoot: {
    width: 'inherit',
    height: '100%',
    display: 'block',
  },
  iconButton: {
    fontSize: '20px',
    padding: '6px',
  },
  due: {
    color: theme.palette.other.dueTxn,
  },
  overdue: {
    color: theme.palette.other.overdueTxn,
  },
  notdue: {
    color: theme.palette.text.tertiary,
    opacity: 0.90,
  },
  editHover: {
    '&:hover': {
      background: theme.mixins.register.fieldHoverColor,
    },
    '&:active': {
      border: `solid 1px ${theme.mixins.register.fieldBorderColor}`,
    },
  },
  dateField: {
    fontSize: theme.mixins?.register?.fontSize?.default,
  },
  pending: {
    color: theme.components?.register?.pendingTextColor,
  },
  bankOwnedPendingText: {
    fontStyle: 'italic',
    opacity: 0.60,
  },
  txnInC2RText: {
    fontStyle: 'italic',
  },
  bankPendingText: {
    opacity: 0.60,
  },
  bankPending: {
    display: 'flex',
    cursor: 'pointer',
    color: theme.palette.text.tertiary,
    fontSize: '16px',
  },
  accountColorDiv: {
    height: '100%',
    minHeight: 20,
    width: '40%',
  },
  acceptBalanceButton: {
    color: 'steelBlue',
    cursor: 'pointer',
    fontWeight: 500,
    outline: 'none',
    fontStyle: 'normal', 
    paddingTop: 2,
    paddingBottom: 2,
    minWidth: 50,
  },
  balanceAmount: {
    paddingRight: 10,
  },
});
